export function convertUrlsToLinks(text: string): string {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" class="underline text-SeabiscuitMainThemeColor hover:opacity-50 transition-all" rel="noopener noreferrer">${url}</a>`
  })
}
